/** Google Ads tag ID from Ads setup (public). */
export const GOOGLE_ADS_ID = "AW-18379963088"

const gtag = (...args) => {
    if (typeof window === "undefined" || typeof window.gtag !== "function") return
    window.gtag(...args)
}

/**
 * Fire when a website enquiry is accepted by the API.
 * Set REACT_APP_GOOGLE_ADS_CONVERSION_SEND_TO to the full send_to value from Ads
 * (e.g. AW-18379963088/xxxxxxxx) once Google shows the conversion snippet.
 */
export const trackEnquiryConversion = () => {
    gtag("event", "generate_lead", {
        event_category: "enquiry",
        event_label: "contact_form",
    })

    const sendTo =
        (process.env.REACT_APP_GOOGLE_ADS_CONVERSION_SEND_TO || "").trim() ||
        "AW-18379963088/C4trCNji4d4cENDln7xE"

    gtag("event", "conversion", {
        send_to: sendTo,
        value: 1.0,
        currency: "GBP",
    })
}
